import { DecodeJWT } from "../helpers";
import * as Sections from "./Sections";

const Routes = {
    order: Sections.OrderSection,
    registry: Sections.RegistrySection,
    user: Sections.UserSection,
    reporting: Sections.ReportingSection,
    stock: Sections.StockSection,
    invoice: Sections.InvoiceSection,
    receiving: Sections.ReceivingSection,
    hubOperation: Sections.HubOperationTable,
    setting: Sections.SettingSection,
    dashboard: Sections.Dashboard,
};

export const GenerateRoutes = () => {
    let routes: any[] = [];
    const token = !!localStorage.getItem("access_token")
        ? DecodeJWT(JSON.parse(localStorage.getItem("access_token")!))
        : null;

    const sections = token?.sections;

    for (let key in sections) {
        //@ts-ignore
        let currentRoute = Routes[key];
        if (currentRoute) {
            let currentSubRoutes = currentRoute.SubRoutes(sections[key], key);
            routes.push({ ...currentRoute, subRoutes: currentSubRoutes });
        }
    }

    return routes;
};
